module.exports = __webpack_public_path__ + "static/media/gabriel_3.1dfc3252.png";